export const PRODUCT_PAGE_QUERY = `
  query ProductPage($handle: String!) {
    page(handle: $handle) {
      body,
      title
    }
  }
`;

export type ProductPageQueryVariants = {
  handle: string;
};

export type ProductPageQueryResponse = {
  page: Page | null;
};

type Page = {
  body: string;
  title: string;
};
